"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Tags = _interopRequireDefault(require("./Tags.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Tags = function Tags(_ref) {
  var classNames = _ref.classNames,
    tags = _ref.tags;
  var css = (0, _Tags.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(classNames, css.tags, "mco-shop-tags")
  }, tags === null || tags === void 0 ? void 0 : tags.map(function (_ref2, index) {
    var _clsx;
    var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "default" : _ref2$color,
      title = _ref2.title;
    return /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: (0, _clsx2.default)(css.tag, "mco-shop-tags__tag", (_clsx = {}, _defineProperty(_clsx, css === null || css === void 0 ? void 0 : css[color], color), _defineProperty(_clsx, "mco-shop-tags__tag--".concat(color), color), _clsx)),
      key: index
    }, title);
  }));
};
var _default = Tags;
exports.default = _default;